// "Keyword Manager" entry of the Volto Site Setup (Jason, 2026-10-04 5:36 PM).
// Volto links every control panel to /controlpanel/<id>, so this route opens the
// classic-UI Keyword Manager (Products.PloneKeywordManager) on the admin host in a
// new tab and returns to Site Setup. If the browser blocks the pop-up, or the page
// is opened directly, it shows a button instead. The target is protected by
// Apache Basic Auth + the Plone login on admin.arkusinc.com.
// URL override per deployment: RAZZLE_KEYWORD_MANAGER_URL (runtime env, compose).
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Segment, Button } from 'semantic-ui-react';

export const DEFAULT_KEYWORD_MANAGER_URL =
  'https://admin.arkusinc.com/prefs_keywords_view';

export const keywordManagerUrl = () =>
  (typeof window !== 'undefined' && window.env?.RAZZLE_KEYWORD_MANAGER_URL) ||
  process.env.RAZZLE_KEYWORD_MANAGER_URL ||
  DEFAULT_KEYWORD_MANAGER_URL;

const KeywordManagerLink = () => {
  const history = useHistory();
  const [blocked, setBlocked] = useState(false);
  const url = keywordManagerUrl();

  useEffect(() => {
    // Only right after a click in Site Setup (client-side PUSH navigation); a direct
    // load or reload has no user gesture and pop-ups would be blocked anyway.
    if (history.action !== 'PUSH') return;
    const w = window.open(url, '_blank');
    if (w) {
      try {
        w.opener = null;
      } catch (e) {
        // ignore
      }
      history.goBack();
    } else {
      setBlocked(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container className="controlpanel keyword-manager-link">
      <Segment.Group raised>
        <Segment className="primary">Keyword Manager</Segment>
        <Segment>
          <p>
            The Keyword Manager (rename, merge or delete tags) runs in the
            classic Plone admin interface. It opens in a new tab and asks for
            the admin site login and then the Plone login.
          </p>
          {blocked && (
            <p>
              <strong>The browser blocked the new tab.</strong> Use the button
              below.
            </p>
          )}
          <Button
            as="a"
            primary
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Keyword Manager (new tab)
          </Button>{' '}
          <Link to="/controlpanel">Back to Site Setup</Link>
        </Segment>
      </Segment.Group>
    </Container>
  );
};

export default KeywordManagerLink;
